<template>
  <div class="row justify-content-center mt-5">
  <div class="col-xl-3 col-lg-4 col-md-6 mb-4">
    <div class="resp-card"  @click="openModal('/Chancelier.jpg')">
      <div class="resp-photo">
        <img src="/Chancelier.jpg" alt=""  @click="openModal('/Chancelier.jpg')">
      </div>
      <h4 class="resp-name">Mgr Roger Houngbédji</h4>
      <p class="resp-role">Chancelier</p>
    </div>
  </div>
  <div class="col-xl-3 col-lg-4 col-md-6 mb-4">
    <div class="resp-card" @click="openModal('/2.jpg')">
      <div class="resp-photo">
        <img src="/2.jpg" alt="" @click="openModal('/2.jpg')">
      </div>
      <h4 class="resp-name">Père Rodrigue Gbédjinou</h4>
      <p class="resp-role">Directeur et Responsable Service de la recherche et de l’innovation méthodologique </p>
    </div>
  </div>
</div>
<h1 class="text-center">Les formateurs</h1>
<div class="row justify-content-center mt-5">
  <div class="col-xl-3 col-lg-4 col-md-6 mb-4">
    <div class="resp-card" @click="openModal('/2.jpg')">
      <div class="resp-photo">
        <img src="/2.jpg" alt="" @click="openModal('/2.jpg')">
      </div>
      <h4 class="resp-name">Père Rodrigue Gbédjinou </h4>
      <p class="resp-role">Formateur</p>
    </div>
  </div>
  <div class="col-xl-3 col-lg-4 col-md-6 mb-4">
    <div class="resp-card">
      <div class="resp-photo" @click="openModal('/Père Narcisse BAH-KPEVI.jpeg')">
        <img src="/Père Narcisse BAH-KPEVI.jpeg" alt="" @click="openModal('/Père Narcisse BAH-KPEVI.jpeg')">
      </div>
      <h4 class="resp-name">Père Narcisse Bah-Kpêvi</h4>
      <p class="resp-role">Formateur</p>
    </div>
  </div>
  <div class="col-xl-3 col-lg-4 col-md-6 mb-4">
    <div class="resp-card" @click="openModal('/Père Romuald HOUNSA.JPG')">
      <div class="resp-photo">
        <img src="/Père Romuald HOUNSA.JPG" alt="" @click="openModal('/Père Romuald HOUNSA.JPG')">
      </div>
      <h4 class="resp-name">Père Romuald Hounsa</h4>
      <p class="resp-role">Formateur</p>
    </div>
  </div>
</div>
<div v-if="isModalOpen" class="image-modal" @click.self="closeModal">
    <div class="modal-content">
      <span class="close-btn" @click="closeModal">&times;</span>
      <img :src="selectedImage" class="modal-image" />
    </div>
  </div>


</template>

<script lang="ts">
import { defineComponent, ref } from "vue";

export default defineComponent({
  name: "AdminSection",
  setup() {
    const isModalOpen = ref(false);
    const selectedImage = ref("");

    const openModal = (image: string) => {
      selectedImage.value = image;
      isModalOpen.value = true;
    };

    const closeModal = () => {
      isModalOpen.value = false;
      selectedImage.value = "";
    };

    return {
      isModalOpen,
      selectedImage,
      openModal,
      closeModal,
    };
  },
});
</script>

<style scoped>
/* Colonne flexible pour aligner les cartes */
.col-xl-3,
.col-lg-4,
.col-md-6 {
  display: flex;
}

/* Carte : flexible mais hauteur automatique */
.resp-card {
  display: flex;
  flex-direction: column;
  align-items: center;       /* centre horizontalement */
  justify-content: flex-start; /* photo en haut */
  background: white;
  border-radius: 15px;
  padding: 25px;
  text-align: center;
  box-shadow: 0 4px 15px rgba(0,0,0,0.08);
  transition: 0.3s;
  width: 100%;               /* carte prend toute la largeur de sa colonne */
}

/* Hover */
.resp-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 8px 25px rgba(0,0,0,0.15);
}

/* Photo ronde fixe */
.resp-photo {
  width: 120px;
  height: 120px;
  margin-bottom: 15px;
  border-radius: 50%;
  overflow: hidden;
  border: 4px solid #0b1b3f;
  flex-shrink: 0;  /* empêche la photo de rétrécir */
  object-fit: cover; 
}

/* Nom et rôle : inchangés */
.resp-name {
  font-size: 1.2rem;
  font-weight: 700;
  color: #0b1b3f;
  margin-bottom: 5px;
}

.resp-role {
  font-size: 20px;
  font-weight: 600;
  color: #6c757d;
  border-left: 4px solid #ffc107;
  padding-left: 10px;
    text-align: center;
  width: 100%;
  box-sizing: border-box;
}
.resp-photo {
  width: 120px;
  height: 120px;
  margin-bottom: 15px;
  border-radius: 50%;
  overflow: hidden;
  border: 4px solid #0b1b3f;
  flex-shrink: 0;  /* empêche la photo de rétrécir */
  display: flex;
}

.resp-photo img {
  width: 100%;
  height: 100%;
  object-fit: cover; /* 🔥 important pour remplir le cercle */
  display: block;
}
.modal-content {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 95vw;
  max-height: 95vh;
}

.modal-image {
  max-width: 90vw;
  max-height: 90vh;
  width: auto;
  height: auto;
  object-fit: contain;
  border-radius: 12px;
  box-shadow: 0 15px 50px rgba(0, 0, 0, 0.6);
}

.close-btn {
  position: absolute;
  top: -10px;
  right: -10px;
  font-size: 30px;
  background: white;
  color: black;
  width: 35px;
  height: 35px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  font-weight: bold;
}
.image-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.75);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  backdrop-filter: blur(4px);
}


</style>